import { AssetfiAssetType } from '@/types/asset-type';

export default function LayersFiledSvg({ width = 24, height = 24 }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 8.5L12 4.5L20 8.5L12 12.5L4 8.5Z" stroke="#357AFF" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M4 12.5L12 16.5L20 12.5"
        stroke="#357AFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16.5L12 20.5L20 16.5"
        stroke="#357AFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
